import { SecurityInventoryItem } from '@x-guard/xgac-types/xgac';
import { LatLngExpression } from 'leaflet';

export const securityItemsResource = 'security-inventory-items';
export const securityInventoryCategoriesResource = 'security-inventory-categories';
export const appUsersResource = 'app-users';

export const hasItemPosition = (item: SecurityInventoryItem) => Boolean(
  item.location.coordinates && item.location.coordinates.length >= 2,
);

export const itemToLatLng = (item: SecurityInventoryItem): LatLngExpression => [
  item.location.coordinates[1],
  item.location.coordinates[0],
];

export type InventoryItemFilter = {
  categories: string[];
  users: string[];
};
